import * as yup from 'yup'

const schema = () =>
  yup.object().shape({
    expirationType: yup.number(),

    dueDate: yup
      .date()
      .typeError('Precisa ser uma data válida')
      .nullable()
      .when('expirationType', {
        is: (expirationType) => expirationType === 0,
        then: yup.date().required().notInPast(),
      }),

    expirationTime: yup.number().when('expirationType', {
      is: (expirationType) => expirationType === 1,
      then: yup
        .number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === '' ? undefined : value,
        )
        .required(),
    }),

    expirationUnit: yup.string().when('expirationType', {
      is: (expirationType) => expirationType === 1,
      then: yup.string().required(),
    }),
  })

export default schema
